export default __webpack_public_path__ + "static/media/favicon.f6a4c897.ico";